import React from "react";
import {Link} from "react-router-dom";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {verboseSymbols} from "../../utils/text";
import MessagePanel from "../MessagePanel";

const NodelessPanel = React.memo(() => {
  const {selectedGenes} = useTheCellMapContext();
  const selectedNodeless = selectedGenes.filter(g => !g.node);

  if (selectedNodeless.length === 0) return null;

  return <MessagePanel
    title="Below network PCC threshold"
    symbols={verboseSymbols(selectedNodeless.map(option => option.symbol))}
    count={selectedNodeless.length}
    message="below the PCC threshold."
    extra={<>You can view interactions for
      {selectedNodeless.length > 1 ? " these genes " : " this gene "}
      in <Link to="/list">List View</Link> or <Link to="/subnetwork">Subnetwork View</Link>.</>}
  />
});

export default NodelessPanel;